import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getTheSupBranch, getDrugInformation, insertOrderAutidDivId } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddProductModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: String,
      defualt: ''
    },
    auditParams: Object
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      prodKeyWord: '',
      branchId: []
    });
    const table = ref();
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        form.value = {
          prodKeyWord: '',
          branchId: []
        };
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const branchList = ref([]);
    getTheSupBranch({}, {
      params: _objectSpread({
        isAll: 1,
        supplierId: props.supplierId
      }, props.auditParams)
    }).then(data => {
      if (data !== null && data !== void 0 && data.length) {
        branchList.value = data;
      }
    });
    const tableOptions = getVexTableProps({
      pagerConfig: {
        pageSize: 10
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '发货方',
        field: 'shortName',
        width: '200px',
        showOverflow: true
      }, {
        title: '药品编码',
        field: 'prodNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '药品名称',
        field: 'prodName',
        width: '150px',
        showOverflow: true
      }, {
        title: '药品规格',
        field: 'proSpec',
        width: '150px',
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacture',
        width: '200px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getDrugInformation(_objectSpread(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId
            }, form.value), props.auditParams), {}, {
              __warn: true
            })).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      emit('success', selectRows);
      visible.value = false; // insertOrderAutidDivId({
      //   supplierId: props.supplierId,
      //   branchIds: selectRows.map((i) => i.branchId).join(','),
      //   prodNos: selectRows.map((i) => i.prodNo).join(','),
      //   prodIds: selectRows.map((i) => i.prodId).join(','),
      //   ...props.auditParams,
      //   __warn: true,
      //   __repeat: true
      // }).then((data) => {
      //   if (data.success) {
      //     emit('success');
      //     ElMessage.success('操作成功!');
      //     visible.value = false;
      //   }
      // });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "商品列表",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "990px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "发货方"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.branchId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.branchId = $event),
                  placeholder: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.shortName,
                      value: item.branchId,
                      key: item.branchId
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "药品名称/编码"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.prodKeyWord,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.prodKeyWord = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                icon: "Search",
                onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};